import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx={12}
      cy={12}
      r={9}
      fill="#C8FBE7"
    />
    <path
      d="M21 12C21 13.7547 20.4871 15.4711 19.5243 16.938C18.5616 18.405 17.191 19.5586 15.5813 20.2568L12 12H21Z"
      fill="#38D695"
    />
    <path
      d="M21 12C21 10.5199 20.635 9.06272 19.9373 7.75743C19.2396 6.45213 18.2308 5.33905 17.0001 4.51677C15.7695 3.6945 14.3551 3.18841 12.8822 3.04334C11.4092 2.89827 9.92325 3.11869 8.55585 3.68508C7.18845 4.25148 5.98185 5.14636 5.04291 6.29046C4.10397 7.43456 3.46168 8.79257 3.17293 10.2442C2.88419 11.6958 2.9579 13.1962 3.38754 14.6126C3.81718 16.0289 4.58948 17.3174 5.63604 18.364L12 12H21Z"
      fill="#0035A4"
    />
    <path
      d="M21 12C21 10.7074 20.7216 9.43002 20.1837 8.25469C19.6458 7.07936 18.861 6.03368 17.8828 5.18879C16.9046 4.34391 15.7559 3.71965 14.5148 3.35848C13.2737 2.99731 11.9694 2.90771 10.6906 3.09577L12 12H21Z"
      fill="#0078EF"
    />
  </svg>
);
const SvgPieColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPieColored;
